import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Counter block mode.
 */
import { BlockCipherMode } from './cipher-core.js';
export var CTR = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(CTR, _BlockCipherMode);

  var _super = _createSuper(CTR);

  function CTR() {
    _classCallCheck(this, CTR);

    return _super.apply(this, arguments);
  }

  return _createClass(CTR);
}(BlockCipherMode);

CTR.Encryptor = /*#__PURE__*/function (_CTR) {
  _inherits(_class, _CTR);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      var _words = words; // Shortcuts

      var cipher = this._cipher;
      var blockSize = cipher.blockSize;
      var iv = this._iv;
      var counter = this._counter; // Generate keystream

      if (iv) {
        this._counter = iv.slice(0);
        counter = this._counter; // Remove IV for subsequent blocks

        this._iv = undefined;
      }

      var keystream = counter.slice(0);
      cipher.encryptBlock(keystream, 0); // Increment counter

      counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0; // Encrypt

      for (var i = 0; i < blockSize; i += 1) {
        _words[offset + i] ^= keystream[i];
      }
    }
  }]);

  return _class;
}(CTR);

CTR.Decryptor = CTR.Encryptor;